import React, { useEffect, useRef } from 'react';

import { StyledPhoneInput } from './PhoneInput.styles';

import { PhoneInputProps } from './PhoneInput.types';
import ReactPhoneInput from 'react-phone-input-2';

const PhoneInput = ({
  value: rawValue, // stored in Redux by parent
  defaultCountry = 'us',
  phoneInputPlaceholder = '',
  specialLabel = '',
  phonePrefix = '+',
  handleClickOutside,
  handleChange,
  handleFocus,
  handleBlur,
  limitedCountryList,
  autoComplete,
  hasError = false,
  isDisabled = false,
  isRequired = false,
  additionalContent,
  componentClassname = 'phone-input',
  customClassnames = '',
  customStyle = '',
}: PhoneInputProps) => {
  /* -------------------------------------------- */
  /* ----------------- STATES  ------------------ */
  /* -------------------------------------------- */
  const wrapperRef = useRef(null);

  /* -------------------------------------------- */
  /* ----------------- EVENTS  ------------------ */
  /* -------------------------------------------- */
  useEffect(() => {
    document.addEventListener('pointerdown', handleClickOutsideLocal);
    return () => {
      document.removeEventListener('pointerdown', handleClickOutsideLocal);
    };
  }, []);

  function handleClickOutsideLocal(event: PointerEvent) {
    if (
      wrapperRef &&
      !wrapperRef.current.contains(event.target) &&
      handleClickOutside
    ) {
      handleClickOutside(event);
    }
  }

  function handleChangeLocal(
    phoneInputValue: string | { number: string },
    country: { countryCode: string },
  ) {
    if (handleChange) {
      const { countryCode } = country;
      let value = phoneInputValue;
      if (
        typeof phoneInputValue !== 'string' &&
        phoneInputValue?.number !== undefined
      ) {
        value = phoneInputValue.number;
      }
      handleChange('+' + value, countryCode); // update rawValue via parent
    }
  }

  return (
    <StyledPhoneInput
      ref={wrapperRef}
      className={`${componentClassname} ${
        hasError ? `${componentClassname}--has-error` : ''
      } ${customClassnames}`}
      customStyle={customStyle}
    >
      <ReactPhoneInput
        country={defaultCountry.toLowerCase()}
        value={rawValue}
        placeholder={phoneInputPlaceholder}
        prefix={phonePrefix}
        disabled={isDisabled}
        onChange={handleChangeLocal}
        onFocus={handleFocus}
        onBlur={handleBlur}
        containerClass={`${componentClassname}__input-wrapper`}
        inputClass={`${componentClassname}__input`}
        buttonClass={`${componentClassname}__button`}
        preferredCountries={[defaultCountry.toLowerCase()]}
        specialLabel={specialLabel}
        onlyCountries={
          limitedCountryList &&
          limitedCountryList.length &&
          limitedCountryList.map((code) => code.toLowerCase())
        }
        inputProps={{
          required: isRequired,
          autoComplete,
        }}
      />
      {additionalContent}
    </StyledPhoneInput>
  );
};
PhoneInput.displayName = 'PhoneInput';

export default PhoneInput;
